<div mat-dialog-container>
  <div mat-dialog-content>
    <div class="close-row">
      <a (click)="close()">
        <img
          class="close-icon"
          src="assets/images/shared/Icon - Close - Active.svg"
        />
      </a>
    </div>
    <div class="modal-title" style="text-align: center">
      {{ "RESET_PASSWORD.TOU_LINK_TEXT" | translate }}
    </div>
    <div class="terms-of-use-body">
      <div class="std-fs-s std-fs-md-xs std-fw-normal text-justify">
        <p>
          <b>{{ "FOOTER.TERMS_GENERAL" | translate }}</b> <br />
          {{ "FOOTER.TERMS_GENERAL_BODY" | translate }} <br /><br />{{
            "FOOTER.TERMS_GENERAL_BODY_2" | translate
          }}
          <br />

          <br /><b>{{ "FOOTER.TERMS_USE_ALLIANZ" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_USE_ALLIANZ_BODY" | translate }} <br />

          <br /><b>{{ "FOOTER.TERMS_NO_DUTY_UPDATE" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_NO_DUTY_UPDATE_BODY" | translate }}<br />

          <br /><b>{{ "FOOTER.TERMS_COPYRIGHT" | translate }}</b> <br />
          {{ "FOOTER.TERMS_COPYRIGHT_BODY" | translate }} <br />

          <br /><b>{{ "FOOTER.TERMS_TRADEMARKS" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_TRADEMARKS_BODY" | translate }}<br />

          <br /><b>{{ "FOOTER.TERMS_NO_WARRANTY" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_NO_WARRANTY_BODY" | translate }} <br /><br />
          {{ "FOOTER.TERMS_NO_WARRANTY_BODY_2" | translate }} <br /><br />
          {{ "FOOTER.TERMS_NO_WARRANTY_BODY_3" | translate }} <br />

          <br /><b>{{ "FOOTER.TERMS_DISCLAIMER_LIABILITY" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_DISCLAIMER_LIABILITY_BODY" | translate }}
          <br />

          <br /><b>{{ "FOOTER.TERMS_DISCLAIMERS" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_DISCLAIMERS_BODY" | translate }}<br />

          <br /><b>{{ "FOOTER.TERMS_HYPERLINKS" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_HYPERLINKS_BODY" | translate }}<br /><br />
          {{ "FOOTER.TERMS_HYPERLINKS_BODY_2" | translate }}<br /><br />
          {{ "FOOTER.TERMS_HYPERLINKS_BODY_3" | translate }} <br />

          <br /><b>{{ "FOOTER.TERMS_LOCAL_RESTRICTIONS" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_LOCAL_RESTRICTIONS_BODY" | translate }} <br />

          <br /><b>{{ "FOOTER.TERMS_RESERVATIONS" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_RESERVATIONS_BODY" | translate }} <br />

          <br /><b>{{ "FOOTER.TERMS_SEVERABILITY" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_SEVERABILITY_BODY" | translate }}<br />

          <br /><b>{{ "FOOTER.TERMS_JURISDICTION" | translate }}</b
          ><br />
          {{ "FOOTER.TERMS_JURISDICTION_BODY" | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
